export const SUPPORTED_LICENSES: ReadonlyArray<string> = [
  "CC-BY-4.0",
  "CC-BY-SA-4.0",
  "CC0-1.0",
  "ARR",
];

export const DEFAULT_LICENSE = "CC-BY-4.0";

const CANONICAL = new Map(SUPPORTED_LICENSES.map((tag) => [tag.toUpperCase(), tag]));

export function normalizeLicense(value: string | null | undefined): string {
  if (value === null || value === undefined) return DEFAULT_LICENSE;
  const trimmed = value.trim();
  if (trimmed === "") return DEFAULT_LICENSE;
  const canonical = CANONICAL.get(trimmed.toUpperCase());
  if (!canonical) {
    throw new Error(`unsupported license: ${value}`);
  }
  return canonical;
}
